$(function () {
  console.log("Rashguard JS");
  // Change t-shirt design when clicking on icons
  $('.rashguard-block__button').click(function() {
      var imageUrl = $(this).attr('data-color-1'); // Use .attr() instead of .data()
      $('.rash-img-wrapper img').attr('src', imageUrl);
  });
  
});


// Place this in a script tag at the bottom of product.liquid or in a theme JS file
// Using vanilla JS here as it's cleaner for event listeners, but it works alongside jQuery.

document.addEventListener('DOMContentLoaded', function() {
  // Find the product form element on the page. It often has a `data-product-form` attribute or is a <product-form> tag.
  console.log("Variant custom JS");
  
  const productForm = document.querySelector('product-form');

  if (productForm) {
    // Listen for the theme's custom event for when the variant changes.
    // 'variant:change' is a common name used in the Dawn theme and its derivatives.
    // You may need to inspect your theme's JS to find the exact event name.
    productForm.addEventListener('variant:change', function(event) {
      // The event.detail object usually contains the variant data.
      const variant = event.detail.variant;

      if (variant) {
        // The variant object has a boolean 'available' property. This is the source of truth!
        if (variant.available) {
          document.body.classList.remove('aw-unavailable');
        } else {
          document.body.classList.add('aw-unavailable');
        }
      } else {
        // If no variant is selected (e.g., all options are sold out), handle that case.
        document.body.classList.add('aw-unavailable');
      }
    });

    // Also, you might want to trigger the check once on page load for the initial variant
    const initialVariantId = new URL(window.location).searchParams.get('variant');
    // ... logic to get initial variant data and run the check.
    // However, a well-built theme often fires the 'variant:change' event on load anyway.
  }
});


// This class is used to disable parallax on touch devices
$(function () {
    if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
      $('body').addClass('touch-device');
  } else {
      $('body').addClass('no-touch-device');
  }
});


(function ($) {
  if (!$) return;

  function initLazyBg($container) {
    if (!$container.length) return;
    var applied = false;

    function chooseSrc() {
      return window.matchMedia('(max-width: 768px)').matches
        ? $container.attr('data-bg-mobile')
        : $container.attr('data-bg-desktop');
    }

    function apply() {
      if (applied) return;
      var src = chooseSrc();
      if (!src) return;

      var img = new Image();
      img.onload = function () {
        $container.css('background-image', 'url("' + src + '")');
        applied = true;
      };
      img.src = src;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            apply();
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      io.observe($container.get(0));
    } else {
      apply();
    }

    // Swap on breakpoint change (desktop <-> mobile) after first load
    var mq = window.matchMedia('(max-width: 768px)');
    var last = mq.matches ? 'm' : 'd';
    function maybeSwap() {
      var mode = mq.matches ? 'm' : 'd';
      if (mode !== last && applied) {
        $container.css('background-image', 'url("' + chooseSrc() + '")');
        last = mode;
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', maybeSwap);
    else if (mq.addListener) mq.addListener(maybeSwap);
  }

  // Run after DOM is parsed (defer guarantees this) and skip the theme editor
  $(function () {
    if (window.Shopify && Shopify.designMode) return;
    $('.aw-section.banner-large-parallax .container').each(function () {
      initLazyBg($(this));
    });
  });
})(window.jQuery);
